import ContactTableRow from "../../components/Contact/ContactTableRow";
import Table from "../../components/Table";
import Error from "../../components/ui/Error";
import { useGetContactQuery } from "../../features/contact/contactApi";
import useWindowDimensions from "../../hooks/useWindowDimensions";
export default function ContactList() {
  const { height } = useWindowDimensions();
  const {
    data: contactData,
    isLoading,
    isError,
    isSuccess,
  } = useGetContactQuery();

  let content = "";
  if (isLoading) {
    content = <p>Loading..</p>;
  } else if (!isLoading && isError) {
    content = <Error message="There is some problem" />;
  } else if (isSuccess && contactData.length === 0) {
    content = <Error message="There is no data" />;
  } else if (isSuccess && contactData.length > 0) {
    content = (
      <Table>
        <thead>
          <tr className="text-center">
            <th>Name</th>
            <th>Email</th>
            <th>Subject</th>
            <th>Message</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {contactData.map((contact) => (
            <ContactTableRow key={contact?.id} contact={contact} />
          ))}
        </tbody>
      </Table>
    );
  }

  return (
    <section
      id="educations"
      data-nav-tooltip="Educations"
      className="pp-section pp-scrollable section dark-bg"
      style={{ height: `${height}px` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">{content}</div>
        </div>
      </div>
    </section>
  );
}
